module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('router-link', {
    staticClass: "c-news-thumb u-relative u-block u-marg-b-lg u-overflow-h is-hoverable",
    attrs: {
      "to": _vm.link
    }
  }, [_c('div', {
    staticClass: "c-news-thumb__cover u-relative"
  }, [_c('app-img-bg', {
    staticClass: "c-news-thumb__img u-index--1",
    attrs: {
      "src": _vm.cover,
      "size": "cover"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "c-news-thumb__gradiant u-absolute u-fit-w u-pos-bl u-index--3"
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "c-hub-layer u-absolute u-pos-tl u-fit u-opacity--5 u-index--2"
  }), _vm._v(" "), (_vm.isVideo) ? _c('img', {
    staticClass: "u-absolute u-pos-center  u-index--4",
    attrs: {
      "src": require("../../../assets/videos/icon-play.png"),
      "alt": "Play"
    }
  }) : _vm._e(), _vm._v(" "), _c('app-text-mask', {
    staticClass: "c-news-thumb__title t-text--bold t-text--xl u-uppercase u-absolute u-pos-bl u-marg-x-md u-align-left u-index--5 u-marg-x-xxs@md u-marg-x-xs@lg t-text--lg@xs",
    attrs: {
      "text": _vm._shorten(_vm.title, 45),
      "type": "h2",
      "class-default": "u-color--white",
      "class-over": "u-color--red-pure"
    }
  })], 1), _vm._v(" "), _c('p', {
    staticClass: "u-color--gray u-marg-x-md u-marg-b-sm u-line-height--md u-marg-x-xxs@md u-marg-x-xs@lg",
    domProps: {
      "innerHTML": _vm._s(_vm._getTextSubtracted(150))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "u-marg-x-md u-marg-x-xxs@md u-marg-x-xs@lg",
    class: {
      'u-flex--x u-flex--align-items--center': !!_vm.footer, 'u-align-right': !_vm.footer
    }
  }, [(!!_vm.footer) ? _c('router-link', {
    staticClass: "c-news-thumb__read-more u-color--red t-text--xxs u-uppercase t-text--bold u-flex__item--auto u-relative u-click-area--xxs ",
    attrs: {
      "to": _vm.link
    }
  }, [_c('span', {
    staticClass: "c-news-thumb__read-more__text u-inline-block u-valign-middle u-marg-r-xxs",
    domProps: {
      "innerHTML": _vm._s(_vm.footer)
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "c-news-thumb__read-more__arrow u-valign-middle",
    attrs: {
      "src": require("../../../assets/news/arrow-next.png"),
      "width": "4",
      "height": "12",
      "alt": ">"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.share.mail) ? _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "mail",
      "url": _vm.link,
      "title": _vm.title,
      "content": _vm.share.mail,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.share.facebook) ? _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "facebook",
      "url": _vm.link,
      "title": _vm.title,
      "content": _vm.share.facebook,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.share.twitter) ? _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "twitter",
      "url": _vm.link,
      "title": _vm.title,
      "content": _vm.share.twitter,
      "size": "small"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.share.link) ? _c('app-btn-share', {
    staticClass: "c-news-share-icon",
    attrs: {
      "type": "link",
      "url": _vm.link,
      "title": _vm.title,
      "content": _vm.share.link,
      "size": "small"
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-17017cf8"}!./src/scripts/components/app-news/template.html
// module id = 887
// module chunks = 0